import { debounce } from '~/utils';
import { useEffect } from 'react';

export const useDebouncedEffect = (callback: () => void, dependencies: any[], delay: number) => {
  useEffect(() => {
    const handler = debounce(() => {
      callback();
    }, delay);

    handler();

    return () => {
      handler.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
